module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "teachertips"
  }, [(!_vm.teachertips) ? _c('loading') : _vm._e(), (_vm.teachertips) ? _c('div', [_c('h1', [_vm._v("Tips")]), _c('div', {
    staticClass: "teachertips-content",
    domProps: {
      "innerHTML": _vm._s(_vm.teachertips.content)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa9f81a","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Teachertips.vue
// module id = swdy
// module chunks = 0 1